export default "__VITE_ASSET__DsQAl9WX__"